export const LOAN_VERSION_ORDER = ['21SDPPP', '21PPPLoan', '20PPPLoan'];
